// Gemeinsame Regeln der Listen Kontakte und Aktivitäten, rein und ohne React (mit node --test prüfbar, deshalb nur
// Typ-Importe): gewählte Spalten prüfen, Sortierung aus der Adresse lesen und in die Adresse schreiben.
import type { ListenSortierung, ListenSpalte } from "../../components/smartview/listenVertrag";

/** Gemerkte oder gewählte Spaltenschlüssel gegen die wählbaren prüfen: Unbekanntes fällt weg, feste Spalten kommen immer vorn
 *  dazu, Doppelte fallen weg. Leer oder `null` heißt Standard der Liste. */
export function spaltenWaehlen(gemerkt: readonly string[] | null | undefined, alle: readonly ListenSpalte[], standard: readonly string[]): string[] {
  const bekannt = new Map(alle.map((s) => [s.key, s]));
  const ausgewaehlt = (gemerkt ?? []).filter((k, i, a) => bekannt.has(k) && a.indexOf(k) === i);
  const basis = ausgewaehlt.length ? ausgewaehlt : standard.filter((k) => bekannt.has(k));
  const fest = alle.filter((s) => s.fest && !basis.includes(s.key)).map((s) => s.key);
  return [...fest, ...basis];
}

/** `-name` -> { key: "name", ab: true }. Nur Schlüssel aus `erlaubt` gelten, sonst der Standard. */
export function sortAusParam(param: string | null | undefined, erlaubt: readonly string[], standard: ListenSortierung): ListenSortierung {
  const roh = (param ?? "").trim();
  const ab = roh.startsWith("-");
  const key = roh.replace(/^-/, "");
  return key && erlaubt.includes(key) ? { key, ab } : standard;
}

/** Wert für die Adresse; `null`, wenn es der Standard ist (dann bleibt die Adresse sauber). */
export function sortZuParam(sort: ListenSortierung, standard: ListenSortierung): string | null {
  if (sort.key === standard.key && sort.ab === standard.ab) return null;
  return `${sort.ab ? "-" : ""}${sort.key}`;
}

/** Klick auf einen Spaltenkopf: neue Spalte beginnt mit `ersteRichtungAb` (Daten absteigend, Namen aufsteigend),
 *  dieselbe Spalte kehrt die Richtung um. */
export function sortUmschalten(aktuell: ListenSortierung, key: string, ersteRichtungAb: boolean): ListenSortierung {
  return aktuell.key === key ? { key, ab: !aktuell.ab } : { key, ab: ersteRichtungAb };
}

/** Der Wert, den die Route als `sort` erwartet: `-activity_at`. */
export function sortFuerRoute(sort: ListenSortierung, felder: Readonly<Record<string, string>>): string | undefined {
  const feld = felder[sort.key];
  return feld ? `${sort.ab ? "-" : ""}${feld}` : undefined;
}
